import React, {useRef, useState, setState} from 'react'
import {debounce} from 'lodash';
import moment from 'moment'
moment.locale('sl')


function Comment(props) {
    const [showTextarea, setShowTextarea] = useState(false)
    const [replyText, setReplyText] = useState('Odgovori')
    const [comment, setComment] = useState('')
    const [children, setChildren] = useState(props.comment.children)
    const [scrollAnimation, setScrollAnimation] = useState(props.comment.scroll_animation || false)
    const commentRef = useRef()
    const maxLevel = 6
    const textAreaMaxLength = 1000
    const [charsLeft, setChartsLeft] = useState(textAreaMaxLength)
    const [votesUp, setVotesUp] = useState(props.comment.votes_up)
    const [votesDown, setVotesDown] = useState(props.comment.votes_down)
    const [allAlreadyVoted, setAllAlreadyVoted] = useState(JSON.parse(localStorage.getItem('votes')) || {})
    const [alreadyVoted, setAlreadyVoted] = useState(allAlreadyVoted[`comment_${props.comment.id}`] || undefined)

    let submitDate = moment(props.comment.submit_date).format('DD.MM.YYYY ob kk:mm')

    const nextLevel = props.level + 1
    const listItems = children.map((item, index) => {
        if (nextLevel >= 100) {
            return <></>
        } else {
            return (<Comment key={index} comment={item} level={nextLevel} parentNickname={props.comment.nickname} userAuthorized={props.userAuthorized} userLoggedIn={props.userLoggedIn} csrftoken={props.csrftoken}/>)
        }
    })


    let parent;
    if (props.parentNickname) {
        parent = <span className="comment-parent"><i className="fas fa-share"></i> {props.parentNickname}</span>;
    } else {
        parent = <></>;
    }

    React.useEffect(() => {
        executeScroll()
    }, []);

    const executeScroll = () => {
        if(props.comment.scroll_animation){
            commentRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' })
        }
    };

    const setCookie = () => {
        let referrer = `${window.location.href.replace(/\/+$/, '')}`
        console.log('referrer',referrer)
        document.cookie = `POC_LOCAL_REDIRECT=${referrer};max-age=3600;path=/`
        window.location.href = "/accounts/ellaprovider/login/?process=login";
    }

    const postCommentClick = async event => {
        try {
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': props.csrftoken
                },
                body: JSON.stringify({
                    "parent": props.comment.id,
                    "comment": comment,
                    "article": article_id
                })
            }
            const response = await fetch('/comments/post', config)
            if (response.ok) {
                const new_comment = await response.json()
                new_comment.scroll_animation = true
                setChildren([...children, new_comment])
                setComment('')
                setShowTextarea(false)
                setReplyText('Odgovori')
            } else {
                //
            }
        } catch (error) {
            //
        }
    }



    const replyClick = async event => {
        if(showTextarea){
            setShowTextarea(false)
            setReplyText('Odgovori')
        } else {
            setShowTextarea(true)
            setReplyText('Zapri')
        }
    }

    const voteUpClick = async event => {
        if(alreadyVoted == undefined){
            setAlreadyVoted('true')
            const tmp_all = JSON.parse(localStorage.getItem('votes')) || {}
            const tmp = {
                ...tmp_all,
                [`comment_${props.comment.id}`] : 'true'
            }
            localStorage.setItem('votes', JSON.stringify(tmp))
        }


        try {
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': props.csrftoken
                },
                body: JSON.stringify({})
            }
            const response = await fetch(`/comments/votesup/${props.comment.id}`, config)
            if (response.ok) {
                console.log('vote up ok')
                setVotesUp(votesUp+1)
            } else {
                //
            }
        } catch (error) {
            //
        }
    }

    const voteDownClick = async event => {
        if(alreadyVoted == undefined){
            setAlreadyVoted('true')
            const tmp_all = JSON.parse(localStorage.getItem('votes')) || {}
            const tmp = {
                ...tmp_all,
                [`comment_${props.comment.id}`] : 'true'
            }
            localStorage.setItem('votes', JSON.stringify(tmp))
        }
        try {
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': props.csrftoken
                },
                body: JSON.stringify({})
            }
            const response = await fetch(`/comments/votesdown/${props.comment.id}`, config)
            if (response.ok) {
                console.log('vote down ok')
                setVotesDown(votesDown+1)
            } else {
                //
            }
        } catch (error) {
            //
        }
    }

    const limitTextarea = (comment) => {
        const charCount = comment.length;
        setChartsLeft(textAreaMaxLength - charCount)
    }

    const changedText = comment_value => {
        limitTextarea(comment_value)
    }

    const delayedQuery = debounce(comment_value => changedText(comment_value), 100);

    const onChange = e => {
        setComment(e.target.value)
        delayedQuery(e.target.value);
    };

    return (
        <div id={`comment_${props.comment.id}`}
             className={`comment-holder ${scrollAnimation ? 'scroll_animation':''} ${!props.comment.is_public ? 'disabled-comment':''}`}
             ref={commentRef}>
            <div className="comment-content">
                <div className="comment-content__box1">
                    <div className="avatar"><img src={props.comment.avatar} alt="" className="avatar_img"/></div>
                </div>
                <div className="comment-content__box2">
                    {props.comment.is_public &&
                        <>
                            <div className="user-nickname"><span>{props.comment.nickname}</span>{parent}</div>
                            <div className="submit-date"><i className="fas fa-clock"></i>{submitDate}</div>
                            <div className="comment-text">
                                {props.comment.comment}
                            </div>
                            <div className={`vote-buttons ${alreadyVoted ? 'already_voted' : ''}`}>
                                <span className="votes-up" onClick={() => {
                                    if(!alreadyVoted){
                                        voteUpClick()
                                    }
                                }}>
                                    <span className="votes-up__count">{votesUp}</span><i className="fas fa-thumbs-up"></i>
                                </span>
                                <span className="votes-spacer">
                                    |
                                </span>
                                <span className="votes-down" onClick={() => {
                                    if(!alreadyVoted){
                                        voteDownClick()
                                    }
                                }}>
                                    <span className="votes-down__count">{votesDown}</span><i className="fas fa-thumbs-down"></i>
                                </span>
                            </div>
                            {props.userAuthorized && props.userLoggedIn && props.level<maxLevel &&
                                <>
                                    <div className="reply-label" onClick={() => replyClick()}><i className="fas fa-reply"></i>&nbsp;{replyText}</div>
                                    {showTextarea &&
                                        <>
                                            <textarea className="comment-textarea" rows="4" cols="50"
                                                      autoFocus
                                                      value={comment}
                                                      onChange={onChange}
                                                      type="text"
                                                      placeholder="Dodaj komentar ..."
                                                      maxLength={textAreaMaxLength}></textarea>
                                            <span className="comment_chars_left">Na voljo imate še {charsLeft} znakov.</span>
                                            <button className="btn waves-effect waves-light tags__btn"
                                                    disabled={comment.length>0 ? false:true}
                                                    onClick={() => postCommentClick()}>
                                                POŠLJI
                                            </button>
                                        </>
                                    }
                                </>
                            }
                            {!props.userAuthorized && !props.userLoggedIn && props.level<maxLevel &&
                                <div className={`reply-label socialaccount_provider ellaprovider`}
                                   onClick={() => setCookie()}>
                                    <i className="fas fa-reply"></i>&nbsp;{replyText}
                                </div>
                            }
                            {!props.userAuthorized && props.userLoggedIn && props.level<maxLevel &&
                                <div>
                                    <div className="reply-label" onClick={() => replyClick()}><i className="fas fa-reply"></i>&nbsp;{replyText}</div>
                                    {showTextarea &&
                                        <div className={'not-authorized-holder'}>
                                            <a href={'/novice/slovenija/komentiranje-na-delo-si-na-voljo-le-se-narocnikom/'}
                                                className={`not-authorized-text`}
                                                target={`_blank`}>Komentirajo lahko le prijavljeni uporabniki z aktivno naročnino.</a>
                                        </div>
                                    }
                                </div>
                            }
                        </>
                    }
                    {!props.comment.is_public &&
                        <>
                            <div className="submit-date"><i className="fas fa-clock"></i>{submitDate}</div>
                            <div className="comment-text">
                                {props.comment.comment}
                            </div>
                        </>
                    }
                </div>
            </div>

            <div className='comment-children'>
                {props.comment.is_public &&
                    <>{listItems}</>
                }
            </div>
        </div>
    );
}

export default Comment